module.exports = __webpack_public_path__ + "static/media/cloud-moon.163b031a.svg";